import React from 'react';
import { Dropdown } from 'react-bootstrap';
import { USER_ACTIONS_POPPER_CONFIG } from './userManagementConstants';

export default function UserActionsMenu({
  user,
  onEdit,
  onPassword,
  onDelete,
  isSelf,
}) {
  return (
    <Dropdown
      align="end"
      className="user-management-actions"
      popperConfig={USER_ACTIONS_POPPER_CONFIG}
    >
      <Dropdown.Toggle
        variant="light"
        size="sm"
        className="user-management-actions__toggle"
        id={`user-actions-${user.id}`}
      >
        Akcije
      </Dropdown.Toggle>
      <Dropdown.Menu>
        <Dropdown.Item onClick={() => onEdit(user)}>Uredi uporabnika</Dropdown.Item>
        <Dropdown.Item onClick={() => onPassword(user)} disabled={isSelf}>
          Pošlji povezavo za geslo
        </Dropdown.Item>
        <Dropdown.Divider />
        <Dropdown.Item
          className="text-danger"
          onClick={() => onDelete(user)}
          disabled={isSelf}
        >
          Izbriši uporabnika
        </Dropdown.Item>
      </Dropdown.Menu>
    </Dropdown>
  );
}
